import { render, staticRenderFns } from "./RoomDelivery.vue?vue&type=template&id=71e74b65"
import script from "./RoomDelivery.vue?vue&type=script&lang=js"
export * from "./RoomDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports